export default __webpack_public_path__ + "942ecc1aeead6d81ba943659b765bdcc.png";